import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component"
import memo from "set-state-compare/build/memo"
import PropTypes from "prop-types"
import propTypesExact from "prop-types-exact"
import React from "react"
import {View} from "react-native"
/**
 * @typedef {object} ComponentsSliderSlideProps
 * @property {unknown} active
 * @property {unknown} children
 * @property {unknown} className
 */

/** @typedef {object} ComponentsSliderSlideState */

/**
 * @extends {ShapeComponent<ComponentsSliderSlideProps, ComponentsSliderSlideState>}
 */
class ComponentsSliderSlide extends ShapeComponent {
  static propTypes = propTypesExact({
    active: PropTypes.bool.isRequired,
    children: PropTypes.node,
    className: PropTypes.string
  })

  render() {
    const {active, children, className} = this.props

    return (
      <View
        children={children}
        dataSet={{
          active,
          class: className,
          component: "slider--slide"
        }}
        style={{display: active ? "flex" : "none"}}
      />
    )
  }
}

export default memo(shapeComponent(ComponentsSliderSlide))
